import { useQuery } from '@tanstack/react-query';
import { applicationGuardrailsQueryOptions } from '../../components/settings/testing-controls/useApplicationGuardrailsTarget';
import { applicationInstructionsQueryOptions } from '../../components/settings/testing-controls/useApplicationTestingInstructionsTarget';

export function useTestingControls(applicationId: string) {
  const enabled = applicationId.length > 0;
  const customGuardrailCount = useQuery({
    ...applicationGuardrailsQueryOptions(applicationId),
    select: (response) =>
      (response?.guardrails ?? []).filter((guardrail) => !guardrail.isDefault)
        .length,
    enabled,
  });
  const instructionCount = useQuery({
    ...applicationInstructionsQueryOptions(applicationId),
    select: (response) => response?.notes?.length ?? 0,
    enabled,
  });

  return {
    isLoading: customGuardrailCount.isLoading || instructionCount.isLoading,
    instructionCount: instructionCount.data ?? 0,
    customGuardrailCount: customGuardrailCount.data ?? 0,
  };
}
